export default class Container extends PIXI.Container{
  constructor() {
    super()
  }
}
